/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'
import { resizeFile } from '@/utils/helper'
import { useLocalStorage } from '@/hooks/common'
import useAppStore from '@/store/useAppStore'

interface param {
  file: File
  fileType?: number
}

export const useUploadProfilePicture = () => {
  const axios = useContext(AxiosContext)
  const [basicInfo] = useLocalStorage('ewBasicInfo', null)
  // The Zustand store is reactive (unlike this component-scoped localStorage cache),
  // so it picks up profile data fetched after this hook first mounted — e.g. on
  // /settings, which fetches basic info itself instead of relying on it already
  // being warm from the legacy Header/ResponsiveNavBar mount effect.
  const storeContainerID = useAppStore((state) => state.user.profile?.mobileContID)
  const containerID = storeContainerID || basicInfo?.mobileContID || ''
  return useMutation({
    mutationKey: [ReactQueryKeys.UPLOAD_PROFILE_PICTURE, containerID],
    mutationFn: async ({ file, fileType = 3 }: param) => {
      if (!containerID) {
        throw new Error('User must be authenticated to upload a profile picture')
      }
      const image = await resizeFile(file)

      const formData = new FormData()
      formData.append('egowallFileUpload', image as string)
      formData.append('fileUploadName', 'egowallFileUpload')
      formData.append('fileType', String(fileType))
      formData.append('uploadContainerID', containerID)
      formData.append('format', 'json')
      const response = await axios.api.post('ego/upload-object', formData)
      return response.data
    },
  })
}
